import { render, staticRenderFns } from "./PatiecntCheckUpHistory.vue?vue&type=template&id=1ae01022&scoped=true&"
import script from "./PatiecntCheckUpHistory.vue?vue&type=script&lang=js&"
export * from "./PatiecntCheckUpHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ae01022",
  null
  
)

export default component.exports